import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Select from 'react-select';
import { BlueButton } from '../../components/BlueButton';

import { Wrapper } from './FillParticipant.styled';

export const FillParticipant = ({ participant, onSaved }) => {
  const { name, gender, email, phone, student_id_number } = participant;
  const [state, setState] = useState({
    name: name ? name : '',
    gender: gender ? gender : 'male',
    email: email ? email : '',
    phone: phone ? phone : '',
    student_id_number: student_id_number ? student_id_number : '',
    errorMessage: {
      name: [],
      email: [],
      gender: [],
      phone: [],
    },
  });

  const getErrorMessage = (name) => {
    const errors = state.errorMessage[name];

    return errors.join(' ');
  };

  const handleChangeText = (event) => {
    const { name, value } = event.target;

    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleGenderChange = ({ value }) => {
    setState((prevState) => ({ ...prevState, gender: value }));
  };

  const handleSaveClick = () => {
    if (!state.name.trim()) {
      setState((prevState) => ({
        ...prevState,
        errorMessage: {
          ...prevState.errorMessage,
          name: ['Nama wajib diisi!'],
        },
      }));
    } else if (!state.phone.trim()) {
      setState((prevState) => ({
        ...prevState,
        errorMessage: {
          ...prevState.errorMessage,
          phone: ['Nomor Whatsapp wajib diisi!'],
        },
      }));
    } else {
      onSaved(state);
    }
  };

  const optionStyles = {
    container: (base, state) => ({
      ...base,
      zIndex: 999,
    }),
  };

  return (
    <Wrapper>
      <TextField
        fullWidth
        id="name"
        name="name"
        label="Nama"
        error={!!state.errorMessage.name.length}
        helperText={getErrorMessage('name')}
        value={state.name}
        variant="outlined"
        size="small"
        onChange={handleChangeText}
        autoFocus
      />

      <Select
        fullWidth
        placeholder={state.gender === '' ? 'Jenis Kelamin' : state.gender === 'male' ? 'Laki-laki' : 'Perempuan'}
        isSearchable={false}
        value={state.gender}
        onChange={handleGenderChange}
        options={[
          { value: 'male', label: 'Laki-laki' },
          { value: 'female', label: 'Perempuan' },
        ]}
        styles={optionStyles}
      />

      <TextField
        fullWidth
        id="phone"
        name="phone"
        label="Nomor Whatsapp"
        error={!!state.errorMessage.phone.length}
        helperText={getErrorMessage('phone')}
        value={state.phone}
        type="number"
        variant="outlined"
        size="small"
        onChange={handleChangeText}
      />
      <TextField
        fullWidth
        id="email"
        name="email"
        label="Email"
        value={state.email}
        error={!!state.errorMessage.email.length}
        helperText={getErrorMessage('email')}
        type="email"
        variant="outlined"
        size="small"
        onChange={handleChangeText}
      />
      <TextField
        fullWidth
        id="student_id_number"
        name="student_id_number"
        label="NIP"
        value={state.student_id_number}
        variant="outlined"
        size="small"
        onChange={handleChangeText}
      />
      <BlueButton fullWidth onClick={handleSaveClick} text="Simpan" />
    </Wrapper>
  );
};
